import type { NavItem } from '@/types';

export const MAIN_NAV: NavItem[] = [];

export const FOOTER_LINKS = {
  company: [
    { label: 'About Us', href: '/about' },
  ],
};

export const POPULAR_SEARCHES = [
  'Running Shoes',
  'Cricket Bat',
  'Football',
  'Yoga Mat',
  'Cycling Helmet',
  'Gym Gloves',
  'Badminton Racket',
  'Swimming Goggles',
];





